/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from 'react';
import { Button, Checkbox, FormControlLabel, FormGroup, Grid, TextField, Typography } from '@material-ui/core';
import { ErrorMessage, Formik, Form, Field } from 'formik';
import {
    validationsBonificacao,
    useStyles,
    LoadingComponent,
    initialValuesBonificacao,
    mesDoAno
} from '../../modulos/function/tabelaEdicaoPreco';
import { Dropdown } from 'primereact/dropdown';
import { showMessageAlert, showMessageError, showMessageSuccess } from '../others/toastr';
import mensalidadeService from '../../services/mensalidades/mensalidadeService';
import { decriptObjectOnLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import moment from 'moment';
import { messageWarningButtonCancell } from '../../modulos/function/mensagemSweetAlert';
import { InputNumber } from 'primereact/inputnumber';

const ModalCriarEditarBonificacao = ({
    loadingUpdate,
    handleClose,
    setLoadingUpdate,
    tipoOperacao,
    infoEdit
}) => {
    const [selectedMonths, setSelectedMonths] = useState(mesDoAno);
    const [initialValues, setInitialValues] = useState(initialValuesBonificacao);
    const [tituloModal, setTituloModal] = useState('Cadastro de Abono Mensal');
    const [bloquearInputs, setBloquearInputs] = useState(false);
    const [bonificacaoAplicada, setBonificacaoAplicada] = useState(false);
    const [statusInicial, setStatusInicial] = useState(infoEdit?.status);
    const editarBonificacao = tipoOperacao === 'editar';
    const classes = useStyles();
    const PAGAMENTO_BOLETO = 1;
    const PAGAMENTO_CARTAO = 7;

    useEffect(() => {
        if (editarBonificacao && infoEdit) {
            const dataInicioVigenciaFormatada = new Date(infoEdit.dataInicioVigencia).toISOString().slice(0, 10);
            const dataFinalVigenciaFormatada = new Date(infoEdit.dataFinalVigencia).toISOString().slice(0, 10);

            setStatusInicial(infoEdit.status);

            const mesesEditados = Object.keys(mesDoAno).reduce((acc, month) => {
                acc[month] = infoEdit.parcelaBonificacao.split(';').includes(month.toString());

                return acc;
            }, {});

            const pagamentoCartao = infoEdit.tiposCobrancaIds.includes(PAGAMENTO_CARTAO);
            const pagamentoBoleto = infoEdit.tiposCobrancaIds.includes(PAGAMENTO_BOLETO);

            const temDescontoAplicado = infoEdit.valorDesconto !== null && infoEdit.valorDesconto > 0;

            setInitialValues({
                id: infoEdit.id,
                descricao: infoEdit.descricao,
                status: infoEdit.status,
                parcelaBonificacao: infoEdit.parcelaBonificacao,
                dataInicioVigencia: dataInicioVigenciaFormatada,
                dataFinalVigencia: dataFinalVigenciaFormatada,
                tipoCobranca: infoEdit.tiposCobrancaIds,
                dataInativacao: null,
                valorDesconto: infoEdit.valorDesconto,
                aplicarDesconto: temDescontoAplicado,
                bonificacao: !temDescontoAplicado,
                userCreated: decriptObjectOnLocalStorage('IDuser'),
                pagamentoCartao,
                pagamentoBoleto
            });

            setBonificacaoAplicada(infoEdit.bonificacaoAplicada);
            setSelectedMonths(mesesEditados);
            setTituloModal('Editar Abono Mensal');

            const dataMenorIgualAtual = validaMenorIgualDataAtual(infoEdit.dataInicioVigencia);

            setBloquearInputs(dataMenorIgualAtual);
        }
    }, [infoEdit]);

    const handleMonthChange = month => {
        setSelectedMonths(prev => ({
            ...prev,
            [month]: !prev[month]
        }));
    };

    const validarConcatenarFormaPagamento = values => {
        const formaPagamento = [];

        if (values.pagamentoBoleto) {
            formaPagamento.push(PAGAMENTO_BOLETO);
        }

        if (values.pagamentoCartao) {
            formaPagamento.push(PAGAMENTO_CARTAO);
        }

        if (!formaPagamento.length) {
            showMessageAlert('', 'É necessário selecionar ao menos uma forma de pagamento.', 'toast-top-center');
        }

        return formaPagamento;
    };

    const handleSubmit = values => {
        const selected = Object.keys(selectedMonths).filter(month => selectedMonths[month]);

        const formaPagamento = validarConcatenarFormaPagamento(values);

        if (!formaPagamento.length) {
            return;
        }

        const dataInicio = moment(values.dataInicioVigencia).startOf('day');
        const hoje = moment().startOf('day');

        if (dataInicio.diff(hoje, 'days') < 1 && !editarBonificacao) {
            showMessageAlert('', 'A data de início de vigência deve ser a partir de amanhã.', 'toast-top-center');

            return;
        }

        values.tipoCobranca = formaPagamento;

        if (!selected.length) {
            showMessageAlert('', 'É necessário selecionar ao menos uma parcela para prosseguir.', 'toast-top-center');

            return;
        }

        if (statusInicial && !values.status && !values.dataInativacao) {
            values.dataInativacao = new Date().toISOString().slice(0, 10);
        }

        if (statusInicial === values.status && values.dataInativacao === null) {
            delete values.dataInativacao;
        }

        values.descricao = values.descricao.toUpperCase();
        values.parcelaBonificacao = selected.map(m => m.toString()).join(';');
        delete values.pagamentoBoleto;
        delete values.aplicarDesconto;
        delete values.pagamentoCartao;
        delete values.bonificacao;

        setLoadingUpdate(true);

        if (editarBonificacao) {
            const { id, ...body } = values;

            mensalidadeService.editarBonificacaoMensalidades(id, body)
                .then(() => {
                    showMessageSuccess('', 'Bonificação editada com sucesso!');
                    setLoadingUpdate(false);
                    handleClose();
                })
                .catch(err => {
                    setLoadingUpdate(false);
                    console.error(err);
                    showMessageError('OPS', 'Erro ao editar bonificação!');
                });
        } else {
            mensalidadeService.criarBonificacaoMensalidades(values)
                .then(() => {
                    showMessageSuccess('', 'Bonificação criada com sucesso!');
                    setLoadingUpdate(false);
                    handleClose();
                })
                .catch(err => {
                    setLoadingUpdate(false);
                    console.error(err);
                    showMessageError('OPS', 'Erro ao criar bonificação!');
                });
        }

        setInitialValues(initialValuesBonificacao);
        setSelectedMonths(mesDoAno);
    };

    const deleteBonificacao = async () => {
        handleClose();

        const confirmExclusaoBonificacao = await messageWarningButtonCancell(`Deseja realmente excluir a bonificação "${initialValues.descricao}" ?`);

        if (confirmExclusaoBonificacao.isConfirmed) {
            setLoadingUpdate(true);
            await mensalidadeService.excluirBonificacaoMensalidades(initialValues?.id);
            showMessageSuccess('', 'Bonificação Excluida com sucesso!', 'toast-top-center');
            setLoadingUpdate(false);
        }
    };

    const opcaoStatus = [
        {
            label: 'Ativo',
            value: true
        },
        {
            label: 'Inativo',
            value: false
        }
    ];

    const validaMenorIgualDataAtual = dateString => {
        if (!editarBonificacao) {
            return false;
        }

        const dataVigencia = new Date(dateString);
        const dataAtual = new Date();

        dataAtual.setHours(0, 0, 0, 0);

        const dataMenorIgualAtual = dataVigencia <= dataAtual;

        setBloquearInputs(dataMenorIgualAtual);

        return dataMenorIgualAtual;
    };

    return (
        <div className="ModalStyle PaperModal">
            <Typography variant="h6" gutterBottom>
                {tituloModal}
            </Typography>
            {!loadingUpdate && <div className="dentroModal">
                <Formik
                    onSubmit={handleSubmit}
                    initialValues={initialValues}
                    validationSchema={validationsBonificacao}
                    validate={values => {
                        const context = { bloquearInputs };

                        return validationsBonificacao.validate(values, { context })
                            .then(() => ({}))
                            .catch(err => {
                                const errors = {};

                                if (err.inner) {
                                    err.inner.forEach(({ path, message }) => {
                                        errors[path] = message;
                                    });
                                }

                                return errors;
                            });
                    }}
                    enableReinitialize={true}
                >
                    {({ values, handleSubmit, handleChange, setFieldValue, setFieldTouched }) => (
                        <>
                            <Form>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={12}>
                                        <Field
                                            as={Dropdown}
                                            value={values.status}
                                            name="status"
                                            id="status"
                                            onChange={handleChange}
                                            options={opcaoStatus}
                                            placeholder="Iniciar Abono"
                                            variant="standard"
                                            disabled={(bloquearInputs && !values.status)}
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="status"
                                            style={{ color: 'red' }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <Field
                                            id="descricao"
                                            value={values.descricao}
                                            name="descricao"
                                            onChange={handleChange}
                                            type="string"
                                            label="Descrição"
                                            component={TextField}
                                            style={{ width: '100%' }}
                                            disabled={bloquearInputs}
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="descricao"
                                            style={{ color: 'red' }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Field
                                            as={TextField}
                                            id="dataInicioVigencia"
                                            name="dataInicioVigencia"
                                            label="Data Início Abono"
                                            type="date"
                                            className={classes.textField}
                                            InputLabelProps={{ shrink: true }}
                                            onChange={handleChange}
                                            value={values.dataInicioVigencia}
                                            disabled={bloquearInputs}
                                        />
                                        <ErrorMessage
                                            name="dataInicioVigencia"
                                            component="div"
                                            style={{ color: 'red' }}
                                            className="field-error"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Field
                                            as={TextField}
                                            id="dataFinalVigencia"
                                            name="dataFinalVigencia"
                                            label="Data Final Abono"
                                            type="date"
                                            style={{ width: '100%' }}
                                            className={classes.textField}
                                            InputLabelProps={{ shrink: true }}
                                            onChange={handleChange}
                                            value={values.dataFinalVigencia}
                                            disabled={bloquearInputs}

                                        />
                                        <ErrorMessage
                                            name="dataFinalVigencia"
                                            component="div"
                                            style={{ color: 'red' }}
                                            className="field-error"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Typography variant="subtitle1">Selecione as parcelas para a bonificação:</Typography>
                                        <Grid container spacing={1}>
                                            {Object.entries(selectedMonths).map(([month, isSelected]) => (
                                                <Grid item key={month}>
                                                    <Checkbox
                                                        checked={isSelected}
                                                        onChange={() => handleMonthChange(month)}
                                                        disabled={bloquearInputs}
                                                        color="primary"
                                                    />
                                                    <label>{month}</label>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography variant="subtitle1">Selecione as formas de pagamento:</Typography>
                                        <FormGroup row={true}>
                                            <FormControlLabel
                                                control={<Checkbox color="primary" checked={values.pagamentoCartao} onChange={handleChange} />}
                                                label="Cartão"
                                                id="pagamentoCartao"
                                                name="pagamentoCartao"
                                            />
                                            <FormControlLabel
                                                control={<Checkbox color="primary" checked={values.pagamentoBoleto} onChange={handleChange} />}
                                                label="Boleto"
                                                id="pagamentoBoleto"
                                                name="pagamentoBoleto"
                                            />
                                        </FormGroup>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Typography variant="subtitle1">Adicionar descontos:</Typography>
                                        <FormGroup row={true}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        color="primary"
                                                        checked={values.bonificacao}
                                                        onChange={e => {
                                                            handleChange(e);

                                                            if (e.target.checked) {
                                                                setFieldValue('aplicarDesconto', false);
                                                                setFieldValue('valorDesconto', null);
                                                                setFieldTouched('valorDesconto', false);
                                                            } else {
                                                                if (!values.aplicarDesconto) {
                                                                    setFieldValue('bonificacao', true);
                                                                }
                                                            }
                                                        }}
                                                        name="bonificacao"
                                                        id="bonificacao"
                                                        disabled={bloquearInputs}
                                                    />
                                                }
                                                label="Bonificar Parcelas"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        color="primary"
                                                        checked={values.aplicarDesconto}
                                                        onChange={e => {
                                                            handleChange(e);

                                                            if (e.target.checked) {
                                                                setFieldValue('bonificacao', false);
                                                            } else {
                                                                setFieldValue('valorDesconto', null);
                                                                setFieldTouched('valorDesconto', false);

                                                                if (!values.bonificacao) {
                                                                    setFieldValue('aplicarDesconto', true);
                                                                }
                                                            }
                                                        }}
                                                    />
                                                }
                                                label="Adicionar desconto Parcelas (%)"
                                                id="aplicarDesconto"
                                                name="aplicarDesconto"
                                                disabled={bloquearInputs}
                                            />
                                            {values.aplicarDesconto && (
                                                <Field
                                                    as={InputNumber}
                                                    name="valorDesconto"
                                                    value={values.valorDesconto}
                                                    onValueChange={e => handleChange({
                                                        target: {
                                                            name: 'valorDesconto',
                                                            value: e.value
                                                        }
                                                    })}
                                                    inputClassName={classes.inputPorcentagem}
                                                    mode="decimal"
                                                    suffix="%"
                                                    min={0.1}
                                                    max={100}
                                                    step={0.1}
                                                    disabled={bloquearInputs}

                                                />
                                            )}
                                            <ErrorMessage
                                                name="valorDesconto"
                                                component="span"
                                                style={{
                                                    color: 'red',
                                                    margin: '6px 0 0 5px'
                                                }}
                                            />
                                        </FormGroup>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={12} className={classes.buttonContainer}>
                                    <Button
                                        className={classes.buttons}
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                    >
                                        Salvar
                                    </Button>
                                    {editarBonificacao && (
                                        <>
                                            {!bonificacaoAplicada ? (
                                                <Button
                                                    className={classes.buttonDelete}
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={deleteBonificacao}
                                                >
                                                    Deletar
                                                </Button>
                                            ) : (
                                                <h3 className={classes.msgInfoBotaoDelete}>
                                                    O abono vinculado a um plano, não pode ser excluido.
                                                </h3>
                                            )}
                                        </>
                                    )}
                                    <Button
                                        className={classes.buttonSair}
                                        type="submit"
                                        variant="contained"
                                        color="warning"
                                        onClick={handleClose}
                                    >
                                        Sair
                                    </Button>

                                </Grid>
                            </Form>
                        </>
                    )}
                </Formik>
            </div>}
            {loadingUpdate && <LoadingComponent />}
        </div >
    );
};

export default ModalCriarEditarBonificacao;